import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const NotFound = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        p: 2
      }}
    >
      <Typography variant="h1" color="primary" sx={{ mb: 2, fontSize: { xs: '4rem', md: '6rem' } }}>
        404
      </Typography>
      
      <Typography variant="h4" sx={{ mb: 2 }}>
        Page Not Found
      </Typography>
      
      <Typography variant="body1" color="textSecondary" sx={{ mb: 4, maxWidth: 500 }}>
        The page you are looking for doesn't exist or has been moved.
      </Typography>
      
      <Button 
        variant="contained" 
        color="primary" 
        component={RouterLink} 
        to="/dashboard"
      >
        Back to Dashboard
      </Button>
    </Box>
  );
};

export default NotFound;